












































import { Vue, Component, Watch } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import GameModule from '@/store/modules/Game';
import GeneralModule from '@/store/modules/General';
import UserOnlineModule from '@/store/modules/UserOnline';
import Table from '@/components/Table/Index.vue';
import UserOnlineBody from '@/components/Table/UserOnlineBody.vue';
import UserOnlineData from '@/data/UserOnlineData';
import utils from '@/services/utils';

@Component({
  components: {
    Table,
    UserOnlineBody,
  },
})
export default class UserOnlineView extends Vue {
  GameInstance = getModule(GameModule, this.$store);

  GeneralInstance = getModule(GeneralModule, this.$store);

  UserOnlineInstance = getModule(UserOnlineModule, this.$store);

  utilsInstance = utils;

  TableHead = UserOnlineData.TableHead;

  summaryPlayerData: any = [];

  summaryBotData: any = [];

  userOnline: any = [];

  botOnline: any = [];

  gamesList: any = [];

  mode = 'Players';

  partnerSelected = 'ALL';

  sortList: any = [];

  playerOnlineList: any = [];

  productList: any = [];

  async created() {
    this.GeneralInstance.toggleLoading(true);
    this.partnerSelected = 'ALL';
    const games = await this.GameInstance.FetchGame();
    this.productList = games.products.map((v) => (v.provider === 'Total' ? 'ALL' : v.provider.toUpperCase()));
    this.getUserOnline();
  }

  seletPartner(item) {
    this.partnerSelected = item;
    this.productList.sort();
    this.getUserOnline();
  }

  setMode(val) {
    this.mode = val;
    if (this.mode === 'Bots') {
      // this.emitGetBotOnline();
    } else {
      // this.emitGetPlayerOnline();
    }
  }

  async getUserOnline() {
    const resp = await this.UserOnlineInstance.FetchPlayerOnline({
      partner:
        this.partnerSelected === 'ASKMEBET' ? 'DS' : this.partnerSelected,
    });
    this.playerOnlineList = resp
      .filter((v) => v.activeUser > 0)
      .sort((a, b) => b.activeUser - a.activeUser);
    this.GeneralInstance.toggleLoading(false);
    this.sortList = resp.reduce(
      (unique, item) => (unique.includes(item.partner) ? unique : [...unique, item.partner]),
      [],
    );
  }

  @Watch('$i18n.locale')
  onLanguagChange() {
    this.updatePlayerOnline();
  }

  async updatePlayerOnline() {
    this.summaryPlayerData = await this.gamesList.map((v) => ({
      activeUser: this.userOnline[v.prefix].players,
      name: v.name[this.$i18n.locale],
    }));
    this.summaryPlayerData.push({
      activeUser: this.userOnline.LOBBY.players,
      name: this.$i18n.locale === 'th' ? 'ล็อบบี้' : 'LOBBY',
    });
    this.summaryPlayerData.sort((a, b) => b.activeUser - a.activeUser);
  }

  updateBotOnline() {
    this.summaryBotData = this.gamesList.map((v) => ({
      activeUser: this.botOnline[v.prefix].players,
      name: v.name.en,
    }));
  }
}
